class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.dateString = this.dataset.date; // YYYY-MM-DD
    this.timeString = this.dataset.time || '00:00'; // HH:MM
    
    this.daysEl = this.querySelector('.js-timer-days');
    this.hoursEl = this.querySelector('.js-timer-hours');
    this.minsEl = this.querySelector('.js-timer-mins');
    this.secsEl = this.querySelector('.js-timer-secs');
    
    if (!this.dateString || !this.daysEl) return;
    
    // Create the target date in local timezone
    this.targetDate = new Date(`${this.dateString}T${this.timeString}:00`).getTime();
    
    this.init();
  }

  init() {
    this.updateTimer();
    this.interval = setInterval(() => this.updateTimer(), 1000);
  }

  updateTimer() {
    const now = new Date().getTime();
    const distance = this.targetDate - now;

    if (distance < 0) {
      clearInterval(this.interval);
      // Stay at 0
      this.render(0, 0, 0, 0);
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    this.render(days, hours, minutes, seconds);
  }

  render(days, hours, minutes, seconds) {
    this.daysEl.textContent = this.pad(days);
    this.hoursEl.textContent = this.pad(hours);
    this.minsEl.textContent = this.pad(minutes);
    this.secsEl.textContent = this.pad(seconds);
  }

  pad(num) {
    return num.toString().padStart(2, '0');
  }
}

customElements.define('countdown-timer', CountdownTimer);
